import React from 'react';
import LandingLogo from '../../assets/home.png';
import { Title, Text, TextContainer, Container, StyledButton } from './styles';

export default function Home() {

  return (
    <Container>
      <TextContainer>
        <Title>Uma novidade do Sebrae PE para você</Title>
        <Text>Ari é o atendente virtual do Sebrae que vai te ajudar na sua carreira empreendedora. </Text>
        <Text>Faça seu atendimento agora mesmo. É rápido e prático, 24 horas por dia e sem sair de casa.</Text>

        <StyledButton
          disableRipple={true}
          variant="outlined"
          color="primary"
          href="https://pe.lojavirtualsebrae.com.br/loja/">
          {'Começar o atendimento'}
        </StyledButton>
      </TextContainer>

      <img src={LandingLogo} alt="Logo" style={{ width: '100%', height: 'auto', maxWidth: '100%' }} />
    </Container>
  );
}